/**
 * HTML templates for tournament Prizes and Description.
 * One template per section, with clear emoji-backed copy: the organizer fills the
 * prize [placeholders], while the description's reglamento line is filled from the
 * chosen format (see `resolveDescriptionReglamento`).
 */

export const PRIZE_TEMPLATE = `<p>🥇 <strong>Primer puesto:</strong> [Completa con tu premio]</p>
<p>🥈 <strong>Segundo puesto:</strong> [Completa con tu premio]</p>
<p>🥉 <strong>Tercer puesto:</strong> [Completa con tu premio]</p>`;

const REGLAMENTO_EMOJI = '📋';
const REGLAMENTO_LABEL = 'Reglamento:';
const REGLAMENTO_PENDING =
  'se completará automáticamente con el formato que elijas en el paso "Formato".';

export const REGLAMENTO_HEADING = `${REGLAMENTO_EMOJI} <strong>${REGLAMENTO_LABEL}</strong>`;

/**
 * Stands in for the rules of a format that is picked after the description is
 * written (see `resolveDescriptionReglamento`). Only this exact, untouched text
 * is swapped: once the organizer edits the line it is theirs, and the resolved
 * reglamento shares the heading but never this text.
 */
export const REGLAMENTO_PLACEHOLDER = `<p>${REGLAMENTO_HEADING} <em>${REGLAMENTO_PENDING}</em></p>`;

export const REGLAMENTO_PLACEHOLDER_TEXT = `${REGLAMENTO_EMOJI} ${REGLAMENTO_LABEL} ${REGLAMENTO_PENDING}`;

export const DESCRIPTION_TEMPLATE = `${REGLAMENTO_PLACEHOLDER}
<p>⏰ Presentarse <strong>10 minutos antes</strong> del horario del partido.</p>`;

/** Converts HTML to plain text for clipboard copy. */
export function htmlToPlainText(html: string): string {
  if (!html || !html.trim()) return '';
  const div = document.createElement('div');
  div.innerHTML = html;
  return (div.textContent ?? div.innerText ?? '').trim();
}
